import { useState, useEffect, useCallback, useMemo } from "react";

import { getLabel } from "../../tools/Dictionary";

import "./StyleInput.css";
import { MdOutlineRemoveRedEye, MdMode } from "react-icons/md";

const StyleInput = (props) =>
{

  //Props
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Property = props.Property;
  const Loading = props.Loading;
  const OnChangeValue = props.OnChangeValue;
  const PreviewStyle = props.PreviewStyle;
  const Option = props.Option || {};
  const Type = props.Type;
  const ExampleValue = props.ExampleValue;

  //State
  const [form, setForm] = useState({});
  const [modal, setModal] = useState(false);

  //Variables 
  const optionsWidth = useMemo(() => [
    { value: "100px", label: "100 pixels" },
    { value: "200px", label: "200 pixels" },
    { value: "300px", label: "300 pixels" },
  ], []);

  const optionsFontSize = useMemo(() => [
    { value: "11px", label: "11" },
    { value: "12px", label: "12" },
    { value: "13px", label: "13" },
    { value: "14px", label: "14" },
    { value: "15px", label: "15" },
    { value: "16px", label: "16" },
    { value: "17px", label: "17" },
    { value: "18px", label: "18" },
    { value: "19px", label: "19" },
    { value: "20px", label: "20" },
    { value: "21px", label: "21" },
    { value: "22px", label: "22" },
    { value: "23px", label: "23" },
    { value: "24px", label: "24" },
    { value: "25px", label: "25" },
    { value: "26px", label: "26" },
    { value: "27px", label: "27" },
    { value: "28px", label: "28" },
    { value: "29px", label: "29" },
    { value: "30px", label: "30" }
  ], []);


  const optionsTextAlign = useMemo(() => [
    { value: "center", label: getLabel("StyleInput", "Center") },
    { value: "left", label: getLabel("StyleInput", "Left") },
    { value: "right", label: getLabel("StyleInput", "Right") },
  ], []);

  const optionsColor = useMemo(() => [
    { value: "#0076a5", label: getLabel("StyleInput", "Blue") },
    { value: "black", label: getLabel("StyleInput", "Black") },
    { value: "white", label: getLabel("StyleInput", "White"), isPale: true },
    { value: "#424849", label: getLabel("StyleInput", "Grey") },
    { value: "#b30000", label: getLabel("StyleInput", "Red") },
  ], []);

  const loadData = useCallback((_data) =>
  {
    setForm(_data);
  }, []);


  useEffect(() =>
  {
    loadData(Data);

  }, [Data, loadData]);



  const onChangeFontSize = (e) => {

    setForm(form => ({
      ...form,
      fontSize: e.target.value
    }));

  };

  const onChangeTextAlign = (e) =>
  {

    setForm(form => ({
      ...form,
      textAlign: e.target.value
    }));

  };

  const onChangeFontWeight = (e) => {

    setForm(form => ({
      ...form,
      fontWeight: form.fontWeight == "bold" ? "normal" : "bold"
    }));
}

  const onChangeTextDecoration = (e) =>
  {

    setForm(form => ({
      ...form,
      textDecoration: form.textDecoration == "underline" ? "none" : "underline"
    }));
  }

  const onChangeWidth = (e) => {

    setForm(form => ({
      ...form,
      width: e.target.value
    }));
  };

  const onChangeBackgroundColor = (e) => {

    setForm(form => ({
      ...form,
      backgroundColor: e.target.value
    }));

  };

  const onChangeColor = (e) =>
  {

    setForm(form => ({
      ...form,
      color: e.target.value
    }));

  };
  

  const onClickSave = () =>
  {

    OnChangeValue(form, Property);
    setModal(false);

  };

  const onCloseModal = () =>
  {

    setModal(false);
    loadData(Data);

  };

  const displayValue = (_type) => {

    switch (_type) {
      case "width":
        return form.width || "-";
      case "fontSize":
        const foundFontSize = optionsFontSize.find(f => f.value == form.fontSize)

        if (foundFontSize) return foundFontSize.label;

        return "-";
      case "textAlign":
        const foundTextAlign = optionsTextAlign.find(t => t.value == form.textAlign)

        if (foundTextAlign) return foundTextAlign.label;

        return "-";
      case "backgroundColor":
        return (
          <div className="styleinput_example_color_square" style={{backgroundColor: form.backgroundColor}}></div>
        );
      case "color":
        return (
          <div className="styleinput_example_color_square" style={{ backgroundColor: form.color }}></div>
        );
      default:
        return "-";
    }

  };

  const getExampleStyle = () => {

    switch (Type) {
      case "button":
        return "page_button ";
      default:
        return "";
    }

  };

  const displayModal = () => {

    if (!modal) return null;
    return (
      <div className="page_modal_background">
        <div className="page_modal_cont" style={{ width: "600px" }}>
          <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
            {getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
          <div className="page_modal_body_cont" style={{ padding: "10px" }}>
            <div className="styleinput_example_cont">
              <div className={"styleinput_example_text " + getExampleStyle()}  style={form}>
                {ExampleValue || getLabel("StyleInput", "Example text to test the styling")}
              </div>
            </div>
            <div style={{width: "100%", height: "50px"}} />
            {Option.width &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Width")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "150px" }} >
                  <select
                    value={form.width}
                    className="page_select_input "
                    onChange={onChangeWidth}
                    style={{ width: "100%", textAlign: "center", color: "black" }}
                    disabled={ReadOnly || Loading}
                  >
                    {optionsWidth.map((o, index) => (
                      <option key={index} value={o.value} style={{ textAlign: "center", color: "black" }}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            }
            {Option.fontSize &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Text Size")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <select
                    value={form.fontSize}
                    className="page_select_input "
                    onChange={onChangeFontSize}
                    style={{ width: "100%", textAlign: "center", color: "black" }}
                    disabled={ReadOnly || Loading}
                  >
                    {optionsFontSize.map((o, index) => (
                      <option key={index} value={o.value} style={{ textAlign: "center", color: "black" }}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            }
            {Option.textAlign &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Text Alignment")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <select
                    value={form.textAlign}
                    className="page_select_input "
                    onChange={onChangeTextAlign}
                    style={{ width: "100%", textAlign: "center", color: "black" }}
                    disabled={ReadOnly || Loading}
                  >
                    {optionsTextAlign.map((o, index) => (
                      <option key={index} value={o.value} style={{ textAlign: "center", color: "black" }}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            }
            {Option.fontWeight &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Bold")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <label className="page_switch" style={{ marginRight: "5px", marginBottom: "5px" }}>
                    <input
                      type="checkbox"
                      checked={form.fontWeight == "bold" ? true : false}
                      disabled={ReadOnly || Loading}
                      onChange={onChangeFontWeight}
                    />
                    <span className="page_slider round" />
                  </label>
                </div>
              </div>
            }
            {Option.textDecoration &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Underline")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <label className="page_switch" style={{ marginRight: "5px", marginBottom: "5px" }}>
                    <input
                      type="checkbox"
                      checked={form.textDecoration == "underline" ? true : false}
                      disabled={ReadOnly || Loading}
                      onChange={onChangeTextDecoration}
                    />
                    <span className="page_slider round" />
                  </label>
                </div>
              </div>
            }
            {Option.backgroundColor &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Background Color")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <select
                    value={form.backgroundColor}
                    className="page_select_input "
                    onChange={onChangeBackgroundColor}
                    style={{ width: "100%", textAlign: "center", color: (form.backgroundColor == "white" ? "black" : form.backgroundColor), fontWeight: "bold"}}
                    disabled={ReadOnly || Loading}
                  >
                    {optionsColor.map((o, index) => (
                      <option key={index} value={o.value} 
                        style={{ textAlign: "center", fontWeight: "bold", color: o.value, backgroundColor: (o.value == "white" ? "#b1b1b2" : "white") }}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            }
            {Option.color &&
              <div className="page_modal_body_row">
                <div className="page_modal_body_col_title">
                  {getLabel("StyleInput", "Color")}
                </div>
                <div className="page_modal_body_col_value" style={{ width: "200px" }} >
                  <select
                    value={form.color}
                    className="page_select_input "
                    onChange={onChangeColor}
                    style={{ width: "100%", textAlign: "center", color: (form.color == "white" ? "black" : form.color), fontWeight: "bold" }}
                    disabled={ReadOnly || Loading}
                  >
                    {optionsColor.map((o, index) => (
                      <option key={index} value={o.value}
                        style={{ textAlign: "center", fontWeight: "bold", color: o.value, backgroundColor: (o.value == "white" ? "#b1b1b2" : "white") }}>
                        {o.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            }
          </div>
          
          <div className="page_modal_footer_cont">
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Close")}
              style={{ backgroundColor: "grey", maxWidth: "200px" }}
              onClick={onCloseModal}
              disabled={Loading}
            />
            {!ReadOnly &&
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Confirm")}
                style={{ maxWidth: "200px" }}
                onClick={onClickSave}
                disabled={Loading}
              />
            }
          </div>
        </div>
      </div>
    );

  };


  if (!Data || !form) return null;

  return (
    <div className="styleinput_cont">
      {displayModal()}
      <div className="styleinput_preview_cont">
        <div className="styleinput_preview_item_cont" style={PreviewStyle}>
          {Option.width &&
            <div className="styleinput_preview_item">
              {getLabel("StyleInput", "Width")}: &nbsp;<span>{displayValue("width")}</span>
            </div>
          }
          {Option.fontSize &&
            <div className="styleinput_preview_item">
              {getLabel("StyleInput", "Text Size")}: &nbsp;<span>{displayValue("fontSize")}</span>
            </div>
          }
          {Option.textAlign &&
            <div className="styleinput_preview_item">
              {getLabel("StyleInput", "Text Alignment")}: &nbsp;<span>{displayValue("textAlign")}</span>
            </div>
          }
          {(Option.fontWeight && form.fontWeight == "bold") &&
            <div className="styleinput_preview_item">
              <span>{getLabel("StyleInput", "Bold")}</span>
            </div>
          }
          {(Option.textDecoration && form.textDecoration == "underline") &&
            <div className="styleinput_preview_item">
              <span>{getLabel("StyleInput", "Underline")}</span>
            </div>
          }
          {Option.backgroundColor &&
            <div className="styleinput_preview_item">
              {getLabel("StyleInput", "Background Color")}: &nbsp;<span>{displayValue("backgroundColor")}</span>
            </div>
          }
          {Option.color &&
            <div className="styleinput_preview_item">
              {getLabel("StyleInput", "Color")}: &nbsp;<span>{displayValue("color")}</span>
            </div>
          }


        </div>
        <div className="page_button"
          style={{ width: "180px", height: "30px", fontSize: "20px", marginRight: "5px" }}
          title={getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          onClick={() => setModal(true)}
        >
          <div className="styleinput_preview_col" style={{ width: "30%" }}>
            {ReadOnly ? <MdOutlineRemoveRedEye /> : <MdMode />}
          </div>
          <div className="styleinput_preview_col" style={{ width: "70%" }}>
            {getLabel("LabelInput", (ReadOnly ? "Display" : "Edit"))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StyleInput;